// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".office-object-internals[data-v-3f746a12]{font-size:.9em;line-height:1.2em;margin:.5em 0;padding:0}.office-object-internals .text-primary[data-v-3f746a12]{cursor:pointer}.office-object-internals ul[data-v-3f746a12]{padding-inline-start:unset;background:#f5f5f5;padding:.5em;border-radius:10px}.office-object-internals ul li[data-v-3f746a12]{list-style:none}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
